<template>
  <div class="RLayoutBox IconBox">
    <h3>图标部分展示</h3>
    <el-row :gutter="20" class="icon-list">
      <el-col :span="3" class="icon-item">
        <div class="icon-item-name">computer-line</div>
        <div class="icon-item-component">
          <i class="ri-computer-line"></i>
        </div>
      </el-col>
      <el-col :span="3" class="icon-item">
        <div class="icon-item-name">file-list-line</div>
        <div class="icon-item-component">
          <i class="ri-file-list-line"></i>
        </div>
      </el-col>
      <el-col :span="3" class="icon-item">
        <div class="icon-item-name">home-line</div>
        <div class="icon-item-component">
          <i class="ri-home-line"></i>
        </div>
      </el-col>
      <el-col :span="3" class="icon-item">
        <div class="icon-item-name">pie-chart-line</div>
        <div class="icon-item-component">
          <i class="ri-pie-chart-line"></i>
        </div>
      </el-col>
      <el-col :span="3" class="icon-item">
        <div class="icon-item-name">line-chart-line</div>
        <div class="icon-item-component">
          <i class="ri-line-chart-line"></i>
        </div>
      </el-col>
      <el-col :span="3" class="icon-item">
        <div class="icon-item-name">bar-chart-2-line</div>
        <div class="icon-item-component">
          <i class="ri-bar-chart-2-line"></i>
        </div>
      </el-col>
      <el-col :span="3" class="icon-item">
        <div class="icon-item-name">inbox-unarchive-line</div>
        <div class="icon-item-component">
          <i class="ri-inbox-unarchive-line"></i>
        </div>
      </el-col>
      <el-col :span="3" class="icon-item">
        <div class="icon-item-name">inbox-archive-line</div>
        <div class="icon-item-component">
          <i class="ri-inbox-archive-line"></i>
        </div>
      </el-col>
      <el-col :span="3" class="icon-item">
        <div class="icon-item-name">computer-fill</div>
        <div class="icon-item-component">
          <i class="ri-computer-fill"></i>
        </div>
      </el-col>
      <el-col :span="3" class="icon-item">
        <div class="icon-item-name">file-list-fill</div>
        <div class="icon-item-component">
          <i class="ri-file-list-fill"></i>
        </div>
      </el-col>
      <el-col :span="3" class="icon-item">
        <div class="icon-item-name">home-fill</div>
        <div class="icon-item-component">
          <i class="ri-home-fill"></i>
        </div>
      </el-col>
      <el-col :span="3" class="icon-item">
        <div class="icon-item-name">pie-chart-fill</div>
        <div class="icon-item-component">
          <i class="ri-pie-chart-fill"></i>
        </div>
      </el-col>
      <el-col :span="3" class="icon-item">
        <div class="icon-item-name">line-chart-fill</div>
        <div class="icon-item-component">
          <i class="ri-line-chart-fill"></i>
        </div>
      </el-col>
      <el-col :span="3" class="icon-item">
        <div class="icon-item-name">bar-chart-2-fill</div>
        <div class="icon-item-component">
          <i class="ri-bar-chart-2-fill"></i>
        </div>
      </el-col>
      <el-col :span="3" class="icon-item">
        <div class="icon-item-name">inbox-unarchive-fill</div>
        <div class="icon-item-component">
          <i class="ri-inbox-unarchive-fill"></i>
        </div>
      </el-col>
      <el-col :span="3" class="icon-item">
        <div class="icon-item-name">inbox-archive-fill</div>
        <div class="icon-item-component">
          <i class="ri-inbox-archive-fill"></i>
        </div>
      </el-col>

      <el-col :span="3" class="icon-item">
        <div class="icon-item-name">user-line</div>
        <div class="icon-item-component">
          <i class="ri-user-line"></i>
        </div>
      </el-col>
      <el-col :span="3" class="icon-item">
        <div class="icon-item-name">information-line</div>
        <div class="icon-item-component">
          <i class="ri-information-line"></i>
        </div>
      </el-col>
      <el-col :span="3" class="icon-item">
        <div class="icon-item-name">error-warning-line</div>
        <div class="icon-item-component">
          <i class="ri-error-warning-line"></i>
        </div>
      </el-col>
      <el-col :span="3" class="icon-item">
        <div class="icon-item-name">question-line</div>
        <div class="icon-item-component">
          <i class="ri-question-line"></i>
        </div>
      </el-col>
      <el-col :span="3" class="icon-item">
        <div class="icon-item-name">checkbox-circle-line</div>
        <div class="icon-item-component">
          <i class="ri-checkbox-circle-line"></i>
        </div>
      </el-col>
      <el-col :span="3" class="icon-item">
        <div class="icon-item-name">close-circle-line</div>
        <div class="icon-item-component">
          <i class="ri-close-circle-line"></i>
        </div>
      </el-col>
      <el-col :span="3" class="icon-item">
        <div class="icon-item-name">add-line</div>
        <div class="icon-item-component">
          <i class="ri-add-line"></i>
        </div>
      </el-col>
      <el-col :span="3" class="icon-item">
        <div class="icon-item-name">el-icon-edit</div>
        <div class="icon-item-component">
          <i class="el-icon-edit"></i>
        </div>
      </el-col>

      <el-col :span="3" class="icon-item">
        <div class="icon-item-name">user-fill</div>
        <div class="icon-item-component">
          <i class="ri-user-fill"></i>
        </div>
      </el-col>
      <el-col :span="3" class="icon-item">
        <div class="icon-item-name">information-fill</div>
        <div class="icon-item-component">
          <i class="ri-information-fill"></i>
        </div>
      </el-col>
      <el-col :span="3" class="icon-item">
        <div class="icon-item-name">error-warning-fill</div>
        <div class="icon-item-component">
          <i class="ri-error-warning-fill"></i>
        </div>
      </el-col>
      <el-col :span="3" class="icon-item">
        <div class="icon-item-name">question-fill</div>
        <div class="icon-item-component">
          <i class="ri-question-fill"></i>
        </div>
      </el-col>
      <el-col :span="3" class="icon-item">
        <div class="icon-item-name">checkbox-circle-fill</div>
        <div class="icon-item-component">
          <i class="ri-checkbox-circle-fill"></i>
        </div>
      </el-col>
      <el-col :span="3" class="icon-item">
        <div class="icon-item-name">close-circle-fill</div>
        <div class="icon-item-component">
          <i class="ri-close-circle-fill"></i>
        </div>
      </el-col>
      <el-col :span="3" class="icon-item">
        <div class="icon-item-name">add-fill</div>
        <div class="icon-item-component">
          <i class="ri-add-fill"></i>
        </div>
      </el-col>
      <el-col :span="3" class="icon-item">
        <div class="icon-item-name">edit-fill</div>
        <div class="icon-item-component">
          <i class="ri-edit-fill"></i>
        </div>
      </el-col>
      <el-col :span="3" class="icon-item">
        <div class="icon-item-name">el-icon-delete</div>
        <div class="icon-item-component">
          <i class="el-icon-delete"></i>
        </div>
      </el-col>
      <el-col :span="3" class="icon-item">
        <div class="icon-item-name">el-icon-delete-solid</div>
        <div class="icon-item-component">
          <i class="el-icon-delete-solid"></i>
        </div>
      </el-col>
    </el-row>
    <p>
      <br />
      全部图标演示网址：<a href="htpp://remixicon.com/">http://remixicon.com</a
      >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a
        href="https://element.eleme.io/#/zh-CN/component/icon"
        >https://element.eleme.io/#/zh-CN/component/icon</a
      >
    </p>
  </div>
</template>

<script>
export default {};
</script>
<style lang="scss" scoped>
@import "@/themes/common";
.RLayoutBox {
  height: calc(100vh - 114px) !important;
  overflow-y: auto;
}
.IconBox {
  width: 100%;
  padding: 10px 30px !important;
  a {
    @include font_color("text-color");
  }
  h3 {
    font-size: 20px;
    line-height: 56px;
  }
  .icon-list {
    @include border_color("top", "bg-line-color", solid, 1px);
    @include border_color("left", "bg-line-color", solid, 1px);
    border-radius: 4px;
    box-sizing: border-box;
    .icon-item {
      box-sizing: border-box;
      @include border_color(right, "bg-line-color", solid, 1px);
      @include border_color(bottom, "bg-line-color", solid, 1px);
      height: 140px;

      .icon-item-name {
        padding: 12px;
        overflow: hidden;
        white-space: nowrap;
        text-align: center;
        text-overflow: ellipsis;
      }
      .icon-item-component {
        margin: 10px 0;

        text-align: center;
        i {
          font-size: 36px;
          line-height: 60px;
          &:hover {
            font-size: 56px;
            transition: all 0.2s ease-in;
          }
        }
      }
    }
  }
}
</style>